import {
  FairFareQueryParams,
  getFairFareQueryParams,
} from 'types/interfaces/shared';
import { getBaseURL, getClient } from '../BLL/clients/HttpClient';
import { ApiEndPoint } from '../BLL/Enums/ApiEndPoint';
import { MedicalRecord } from './medicalRecordsService';

export interface ReleaseFormData {
  id: number;
  caseId: string;
  policyNumber: string;
  uploadedBy: string;
  docUrl: string;
  status: string;
  createdAt: Date;
  updatedAt: Date;
  medicalRecords: MedicalRecord[];
}

export interface ReleaseFormPagination {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}

export interface ReleaseFormResponse {
  releaseForms: ReleaseFormData[];
  pagination: ReleaseFormPagination;
}

export interface FairFareReleaseFormsQueryParams extends FairFareQueryParams {
  carrierId?: number;
}

export const getAllReleaseForms = async (
  query: FairFareReleaseFormsQueryParams
): Promise<ReleaseFormResponse> => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });
  const params: any = getFairFareQueryParams(query);

  if (query.carrierId) {
    params.carrierId = query.carrierId;
  }

  const { data } = await client.get<ReleaseFormResponse>('v1/release-forms', {
    params,
  });

  const formattedData = {
    ...data,
    releaseForms: data.releaseForms.map((form) => ({
      ...form,
      createdAt: new Date(form.createdAt),
      updatedAt: new Date(form.updatedAt),
    })),
  };

  return formattedData;
};
